import React from 'react';

interface JsonLdProps {
  data: Record<string, unknown> | Array<Record<string, unknown>>;
  id?: string;
}

// A bare top-level array leaves `@context` undefined for consumers that read it
// off the parsed script; @graph keeps it a string.
const toGraph = (entries: Array<Record<string, unknown>>) => ({
  '@context': 'https://schema.org',
  '@graph': entries,
});

// Rendered inline in the body, not via next/head — valid for structured data and
// router-agnostic (next/head is a no-op under app/).
export const JsonLd: React.FC<JsonLdProps> = ({ data, id }) => {
  if (!data) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('JsonLd: data prop is required');
    }
    return null;
  }

  try {
    const jsonString = JSON.stringify(
      Array.isArray(data) ? toGraph(data) : data,
    );

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonString }}
        {...(id && { id })}
      />
    );
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('JsonLd: Failed to stringify JSON data', error);
    }
    return null;
  }
};
